// src/webideal-jobs/pages/Home.jsx

import React from "react";
import { useQuery } from "@tanstack/react-query";
import backendApi from "@/api/backendApi";

// ❌ REMOVED: TopCompaniesCarousel import
import FiltersSidebar from "../components/companies/FiltersSidebar";
import CompanyCard from "../components/companies/CompanyCard";

// ------------------------------------------------------
// DEMO COMPANIES (Shown when backend has no data)
// ------------------------------------------------------
const demoCompanies = [
  {
    id: "1",
    name: "Priority IDC",
    logo_url: "",
    rating: 3.4,
    reviews_count: 8,
    tags: ["Corporate", "FinTech / Payments"],
    location: "Bangalore",
  },
  {
    id: "2",
    name: "Codevian Technologies",
    logo_url: "",
    rating: 4.3,
    reviews_count: 10,
    tags: ["Corporate", "IT Services & Consulting"],
    location: "Pune",
  },
  {
    id: "3",
    name: "Ozone Overseas",
    logo_url: "",
    rating: 3.9,
    reviews_count: 415,
    tags: ["Corporate", "Building Material"],
    location: "Delhi",
  },
  {
    id: "4",
    name: "Pyrotech Workspace Solutions",
    logo_url: "",
    rating: 3.6,
    reviews_count: 89,
    tags: ["Corporate", "Industrial Equipment"],
    location: "Hyderabad",
  },
];

export default function Home() {
  // Load companies from backend
  const { data: companies } = useQuery({
    queryKey: ["companies"],
    queryFn: () => backendApi.entities.Company.list(),
  });

  // If backend is empty → use demo companies
  const finalCompanies =
    companies && companies.length > 0 ? companies : demoCompanies;

  return (
    <div className="w-full px-4 py-8">

      {/* ❌ TOP CAROUSEL REMOVED (red circled section) */}

      <div className="flex flex-col lg:flex-row gap-8">

        {/* LEFT FILTER SIDEBAR */}
        <div className="w-full lg:w-72">
          <FiltersSidebar />
        </div>

        {/* COMPANY GRID */}
        <div className="flex-1">
          <h2 className="text-xl font-bold text-gray-800 mb-6">
            Showing 6045 companies
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-6">
            {finalCompanies.map((company) => (
              <CompanyCard key={company.id} company={company} />
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}
